import React, { useEffect, useRef, useState } from "react";
import classes from "./MovieCard.module.css";
import Vibrant from "node-vibrant";
import { TrendingArrayType } from "../../Routes/Home";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../Store/hooks";
import { removeTitles, setTitles } from "../../Slices/postTitlesSlice";
import { toast } from "react-toastify";
import { closeSearchModal } from "../../Slices/searchModalSlice";
import {
  removeWatchlistItems,
  setWatchlistItems,
} from "../../Slices/watchlistModalSlice";

export type MovieData = {
  backdrop_path: string;
  id: number;
  title: string;
  name?: string;
  original_name?: string;
  original_title: string;
  overview: string;
  poster_path: string;
  media_type?: string;
  adult: boolean;
  original_language: string;
  genre_ids: string[];
  popularity: number;
  release_date: string;
  video: boolean;
  vote_average: number;
  vote_count: number;
};

const MovieCard = ({
  data,
  navigateTo,
  type,
  watchlist_items,
  media_type,
}: {
  data: MovieData;
  navigateTo?: "movies" | "series";
  watchlist_items?: any[];
  media_type?: "movie" | "tv";
  type?:
    | "select titles and dispatch"
    | "selected titles and remove dispatch"
    | "selected titles in wishlist and remove dispatch"
    | "select titles in wishlist and dispatch";
}) => {
  const navigate = useNavigate();
  const [startPosition, setStartPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);

  const { selectedTitles } = useAppSelector((state) => state.postTitlesSlice);

  const dispatch = useAppDispatch();

  const handleMouseDown = (event: React.MouseEvent<HTMLButtonElement>) => {
    setStartPosition({ x: event.clientX, y: event.clientY });
    setIsDragging(false);
  };

  const handleMouseUp = (
    event: React.MouseEvent<HTMLButtonElement>,
    data: MovieData
  ) => {
    const distance = Math.sqrt(
      Math.pow(event.clientX - startPosition.x, 2) +
        Math.pow(event.clientY - startPosition.y, 2)
    );
    if (distance < 5 && !isDragging) {
      if (type === "selected titles and remove dispatch") {
        dispatch(removeTitles(data));
      } else if (type === "select titles and dispatch") {
        if (selectedTitles.length >= 6) {
          toast.info("You can maximum select 6 titles for a Post!");
          return;
        }
        dispatch(setTitles(data));
      } else if (type === "select titles in wishlist and dispatch") {
        let filteredData = watchlist_items?.filter(
          (dataItem) =>
            dataItem?.media_id === data?.id &&
            dataItem?.media_type === data?.media_type
        );
        console.log(data, "data");
        console.log(filteredData, "filtereddata...");
        if (filteredData && filteredData?.length > 0) {
          toast.error("This item is already in this wishlist!");
          return;
        }

        let updatedData = {
          ...data,
          media_type: data?.media_type || media_type,
        };
        dispatch(setWatchlistItems(updatedData));
      } else if (type === "selected titles in wishlist and remove dispatch") {
        dispatch(removeWatchlistItems(data));
      } else if (navigateTo === "movies") {
        dispatch(closeSearchModal());
        navigate(`/movies/${data?.id}/${data?.title ?? data?.name}`);
      } else {
        dispatch(closeSearchModal());
        navigate(`/series/${data?.id}/${data?.title ?? data?.name}`);
      }
    }
  };

  const handleMouseMove = () => {
    setIsDragging(true);
  };

  return (
    <button
      className={classes.main_card}
      onMouseDown={(event) => handleMouseDown(event)}
      onMouseUp={(event) => handleMouseUp(event, data)}
      onMouseMove={handleMouseMove}
    >
      <div className={classes.main_card_image}>
        <img
          src={`${process.env.REACT_APP_MEDIA_PATH_PREFIX?.replace(
            "<replace_media_id>",
            data?.poster_path
          )}`}
          alt="movie"
          className={classes.main_card_img}
        />
      </div>
      <div className={classes.main_card_content}>
        <p className={classes.main_card_title}>{data?.title ?? data?.name}</p>
      </div>

      {(type === "selected titles and remove dispatch" ||
        type === "selected titles in wishlist and remove dispatch") && (
        <div className={classes.remove_icon}>
          <i className={`pi pi-times ${classes.remove}`} />
        </div>
      )}
    </button>
  );
};

export default MovieCard;
